import React, { memo } from 'react'
import { BasePublisherButton } from 'src/publisher/entities/base-publisher-button'
import useWebsiteLoginSubmit from 'src/publisher/hooks/use-website-login-submit'
import { WebsiteLoginButtonEntityInterface } from 'src/shared/entities/button/website-login-button.schema'

const TEST_ID = 'custom-login-button'

export interface WebsiteLoginButtonProps {
  entity: WebsiteLoginButtonEntityInterface
}

const WebsiteLoginButton = ({ entity }: WebsiteLoginButtonProps) => {
  const [isLoading, errors, submit] = useWebsiteLoginSubmit(entity)

  return (
    <BasePublisherButton
      entityOrSubEntity={entity}
      isLoading={isLoading}
      errors={errors}
      onClick={submit}
      testId={TEST_ID}
    />
  )
}

export default memo(WebsiteLoginButton)
